module.exports = __webpack_public_path__ + "img/loadingycf.94451a40.gif";